"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _CheckBoxOutlineBlank = _interopRequireDefault(require("@material-ui/icons/CheckBoxOutlineBlank"));

var _CheckBox = _interopRequireDefault(require("@material-ui/icons/CheckBox"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _Button = _interopRequireDefault(require("../Button"));

var _default = function _default(_ref) {
  var open = _ref.open,
      emails = _ref.emails,
      onClose = _ref.onClose,
      onConfirm = _ref.onConfirm;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      checked = _useState2[0],
      setCheckBox = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], {
    open: open,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "p-6",
    style: {
      width: 450
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "py-1 text-xl font-semibold"
  }, t('approveSender.block.prompt', {
    count: emails.length
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "flex items-center py-6 text-xs font-light cursor-pointer text-gray-divider hover:text-gray-light"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    type: "checkbox",
    className: "hidden",
    onChange: function onChange(e) {
      return setCheckBox(e.target.checked);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('mr-2', {
      'text-gray-light': checked
    })
  }, checked ? /*#__PURE__*/_react["default"].createElement(_CheckBox["default"], {
    fontSize: "small"
  }) : /*#__PURE__*/_react["default"].createElement(_CheckBoxOutlineBlank["default"], {
    fontSize: "small"
  })), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-gray-light"
  }, t('checkbox.doNotShowAgain'))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    color: "secondary",
    className: "w-32 !py-3 mr-4",
    onClick: onClose
  }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    className: "w-32 !py-3",
    onClick: function onClick() {
      return onConfirm(checked);
    }
  }, t('button.okay')))));
};

exports["default"] = _default;
//# sourceMappingURL=Prompt.js.map